module.exports = __webpack_public_path__ + "static/img/music.6430b5c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup/music.gif
// module id = nIkK
// module chunks = 5